import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, QrCodeIcon, SendIcon, HistoryIcon, RefreshCwIcon, UserIcon, LogOutIcon, ChevronDownIcon, ChevronRightIcon, BarChart3Icon, ListIcon, MessageSquareIcon, ShieldAlertIcon } from 'lucide-react';
interface SidebarProps {
  onLogout: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  onLogout
}) => {
  const location = useLocation();
  const [qrcExpanded, setQrcExpanded] = useState(false);
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <div className="bg-slate-100 w-64 min-h-screen flex-shrink-0 hidden md:flex flex-col border-r border-slate-200" data-id="element-512">
      {/* Logo & Merchant Info */}
      <div className="p-6 border-b border-slate-200" data-id="element-513">
        <div className="flex items-center space-x-3 mb-6" data-id="element-514">
          <img src="https://cdn.magicpatterns.com/uploads/vRyb2gjrsLofr6hM6xeb2a/Paysys_Logo.png" alt="Paysys" className="h-8 w-auto object-contain" data-id="element-515" />
        </div>

        <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm" data-id="element-516">
          <div className="text-sm font-semibold text-slate-800 mb-1" data-id="element-517">
            Gadgets Zone
          </div>
          <div className="flex justify-between items-center text-xs text-slate-500 mb-1" data-id="element-518">
            <span data-id="element-519">MID:</span>
            <span className="font-mono" data-id="element-520">050102100023650</span>
          </div>
          <div className="flex justify-between items-center text-xs text-slate-500" data-id="element-521">
            <span data-id="element-522">TID:</span>
            <span className="font-mono" data-id="element-523">2365010001</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 overflow-y-auto custom-scrollbar" data-id="element-524">
        <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-3" data-id="element-525">
          Main Menu
        </div>
        <ul className="space-y-1.5" data-id="element-526">
          <li data-id="element-527">
            <Link to="/dashboard" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/dashboard') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-528">
              <HomeIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-529" />
              <span className="font-medium text-sm" data-id="element-530">Dashboard</span>
            </Link>
          </li>

          <li data-id="element-531">
            <button onClick={() => setQrcExpanded(!qrcExpanded)} className={`flex items-center justify-between w-full px-3 py-2.5 rounded-lg transition-all duration-200 ${location.pathname.includes('/qrc') ? 'bg-indigo-100 text-indigo-700' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-532">
              <div className="flex items-center" data-id="element-533">
                <QrCodeIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-534" />
                <span className="font-medium text-sm" data-id="element-535">QRC Management</span>
              </div>
              {qrcExpanded ? <ChevronDownIcon className="h-4 w-4" data-id="element-536" /> : <ChevronRightIcon className="h-4 w-4" data-id="element-537" />}
            </button>

            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${qrcExpanded ? 'max-h-40 opacity-100 mt-1' : 'max-h-0 opacity-0'}`} data-id="element-538">
              <ul className="pl-11 space-y-1 relative before:absolute before:left-5 before:top-0 before:bottom-2 before:w-px before:bg-slate-300" data-id="element-539">
                <li data-id="element-540">
                  <Link to="/qrc/static" className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/static') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-541">
                    Static QRC
                  </Link>
                </li>
                <li data-id="element-542">
                  <Link to="/qrc/static-amount" className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/static-amount') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-543">
                    Static QRC with Amount
                  </Link>
                </li>
                <li data-id="element-544">
                  <Link to="/qrc/dynamic" className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/dynamic') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-545">
                    Dynamic Payment QRC
                  </Link>
                </li>
              </ul>
            </div>
          </li>

          <li data-id="element-546">
            <Link to="/request-to-pay" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/request-to-pay') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-547">
              <SendIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-548" />
              <span className="font-medium text-sm" data-id="element-549">Request to Pay</span>
            </Link>
          </li>

          <li data-id="element-550">
            <Link to="/rtp-lists" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/rtp-lists') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-551">
              <ListIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-552" />
              <span className="font-medium text-sm" data-id="element-553">RTP Lists</span>
            </Link>
          </li>

          <li data-id="element-554">
            <Link to="/transaction-history" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/transaction-history') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-555">
              <HistoryIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-556" />
              <span className="font-medium text-sm" data-id="element-557">Transaction History</span>
            </Link>
          </li>

          <li data-id="element-558">
            <Link to="/disputes" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/disputes') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-559">
              <ShieldAlertIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-560" />
              <span className="font-medium text-sm" data-id="element-561">Disputes</span>
            </Link>
          </li>

          <div className="pt-4 pb-2" data-id="element-562">
            <div className="h-px bg-slate-200 w-full" data-id="element-563"></div>
          </div>

          <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-3" data-id="element-564">
            Settings
          </div>

          <li data-id="element-565">
            <Link to="/merchant-assessment" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/merchant-assessment') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-566">
              <BarChart3Icon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-567" />
              <span className="font-medium text-sm" data-id="element-568">Merchant Assessment</span>
            </Link>
          </li>

          <li data-id="element-569">
            <Link to="/update-profile" className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/update-profile') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-570">
              <UserIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-571" />
              <span className="font-medium text-sm" data-id="element-572">Profile Settings</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-slate-200" data-id="element-573">
        <button onClick={onLogout} className="flex items-center px-3 py-2.5 rounded-lg text-slate-600 hover:bg-red-50 hover:text-red-600 w-full transition-colors group" data-id="element-574">
          <LogOutIcon className="h-5 w-5 mr-3 flex-shrink-0 group-hover:text-red-600" data-id="element-575" />
          <span className="font-medium text-sm" data-id="element-576">Logout</span>
        </button>
      </div>
    </div>;
};
export default Sidebar;